export const TRANSFER_FIELD_SELECTOR = '[name="card-number"]'
